import '../styles/feedback.css'
import { useEffect, useState } from 'react'
import { sendFeedback } from '../Services/searchRequest'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faThumbsUp, faThumbsDown } from '@fortawesome/free-solid-svg-icons'

const FeedbackIcons = ({ queryId, resultId, feedback, onFeedback = null }) => {
  const [feedbackSent, setFeedbackSent] = useState(null)
  const [feedbackMessage, setFeedbackMessage] = useState('')

  useEffect(() => {
    if (feedback) {
      setFeedbackSent(feedback.isRelevant)
      setFeedbackMessage(feedback.message)
    }
  }, [feedback])

  const handleFeedback = async (isRelevant) => {
    const response = await sendFeedback(queryId, resultId, isRelevant)
    setFeedbackSent(isRelevant)
    const message = response?.message
    setFeedbackMessage(message)

    if (onFeedback) {
      onFeedback(resultId, isRelevant, message)
    }
  }

  return (
    <div className="feedback-icons">
      <FontAwesomeIcon
        icon={faThumbsUp}
        className={`like-icon ${feedbackSent === true ? 'active' : ''}`}
        onClick={() => handleFeedback(true)}
        tabIndex="0"
        role="button"
        aria-label="Curtir"
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleFeedback(true)}
      />
      <FontAwesomeIcon
        icon={faThumbsDown}
        className={`dislike-icon ${feedbackSent === false ? 'active' : ''}`}
        onClick={() => handleFeedback(false)}
        tabIndex="0"
        role="button"
        aria-label="Não curtir"
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && handleFeedback(false)}
      />
      {feedbackMessage && (
        <div className="feedback-message-box">
          <p>{feedbackMessage}</p>
        </div>
      )}
    </div>
  )
}

export default FeedbackIcons